const indexedArray = (length: number) =>
  Array.from(Array(length)).map((_, index) => index)

export default indexedArray
